var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelopeSimpleOpenWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.847 6.98l-7.5-5a.625.625 0 00-.694 0l-7.5 5a.625.625 0 00-.278.52v8.125a1.25 1.25 0 001.25 1.25h13.75a1.25 1.25 0 001.25-1.25V7.5a.625.625 0 00-.278-.52zM3.125 15.625V8.714l5.148 3.672a.625.625 0 00.364.116h2.726c.13 0 .258-.04.364-.116l5.148-3.672v6.911H3.125z",
    fill: "#fff"
  })));
}

export default SvgEnvelopeSimpleOpenWhite;